import { ToggleButton, ToggleButtonGroup } from '@mui/material'

export default function AdxToggle({ items, view, handleTabChange }) {
  const toggleStyle = (index) => {
    return {
      width: 150,
      borderRadius:
        index === 0 ? '500px 0 0 500px' : index === items.length - 1 ? '0 500px 500px 0' : '0',
      border: '1px solid',
      borderColor: 'grayscale.gray-inactive', // Gray for non-selected state
      '&.Mui-selected': {
        color: 'text.primary',
        backgroundColor: 'primary.light',
        borderColor: 'primary.main', // Primary color for selected state
        '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
          borderLeft: '1px solid',
          borderColor: 'primary.main',
        },
      },
      '&:hover': {
        color: 'primary.text',
        backgroundColor: 'primary.light',
        borderColor: 'grayscale.gray-inactive', // Primary color on hover
      },
      '&.MuiToggleButtonGroup-grouped': {
        borderColor: 'grayscale.gray-inactive', // Gray for non-selected grouped buttons
      },
      '&.MuiToggleButtonGroup-grouped.Mui-selected': {
        borderColor: 'primary.main', // Ensure selected grouped buttons have primary color
      },
    }
  }

  return (
    <ToggleButtonGroup
      color="primary"
      value={view}
      exclusive
      onChange={handleTabChange}
      aria-label="view"
      sx={{ height: '45px' }}
    >
      {items.map((item, index) => {
        return (
          <ToggleButton key={index} value={item.value} sx={{ ...toggleStyle(index) }}>
            {item.label}
          </ToggleButton>
        )
      })}
    </ToggleButtonGroup>
  )
}
